// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__6sIvw","table-head":"Table_table-head__n8HDB","table-body":"Table_table-body__3pU_H"};